import type { Item } from '~/shared/api'
import type { ItemsTableTotals } from './calculate-items-table-totals.types'

const getIntegerValue = (value: unknown) =>
  Number.parseInt(String(value), 10) || 0

export const calculateItemsTableTotals = (items: Item[]): ItemsTableTotals =>
  items.reduce<ItemsTableTotals>(
    (totals, item) => ({
      count: totals.count + getIntegerValue(item.count),
      countInOrders: totals.countInOrders + getIntegerValue(item.countInOrders),
      countInDemands:
        totals.countInDemands + getIntegerValue(item.countInDemands),
      countOzon: totals.countOzon + getIntegerValue(item.countOzon),
      countWB: totals.countWB + getIntegerValue(item.countWB),
      soldLastMonthCount:
        totals.soldLastMonthCount + getIntegerValue(item.soldLastMonthCount),
      soldLastMonthSources: {
        site:
          totals.soldLastMonthSources.site +
          getIntegerValue(item.soldLastMonthSources?.site),
        ozon:
          totals.soldLastMonthSources.ozon +
          getIntegerValue(item.soldLastMonthSources?.ozon),
        wildberries:
          totals.soldLastMonthSources.wildberries +
          getIntegerValue(item.soldLastMonthSources?.wildberries),
        'yandex-market':
          totals.soldLastMonthSources['yandex-market'] +
          getIntegerValue(item.soldLastMonthSources?.['yandex-market']),
        other:
          totals.soldLastMonthSources.other +
          getIntegerValue(item.soldLastMonthSources?.other),
      },
      fboLastMonthCount:
        totals.fboLastMonthCount + getIntegerValue(item.fboLastMonthCount),
      wbSaleLastMonthCount:
        totals.wbSaleLastMonthCount +
        getIntegerValue(item.wbSaleLastMonthCount),
    }),
    {
      count: 0,
      countInOrders: 0,
      countInDemands: 0,
      countOzon: 0,
      countWB: 0,
      soldLastMonthCount: 0,
      soldLastMonthSources: {
        site: 0,
        ozon: 0,
        wildberries: 0,
        'yandex-market': 0,
        other: 0,
      },
      fboLastMonthCount: 0,
      wbSaleLastMonthCount: 0,
    },
  )
